// Standard outcome templates (spec 4a). A default list, not an enum:
// outcomes store template_key for cross-demo reporting, and custom outcomes use null.

export interface OutcomeTemplate {
  key: string;
  name: string;
  description: string;
}

export const OUTCOME_TEMPLATES: OutcomeTemplate[] = [
  { key: "solve_pain", name: "Solve a pain point", description: "Has a specific problem today, like constant phishing or a noisy tool." },
  { key: "reduce_risk", name: "Reduce risk", description: "Focused on exposure and preventing incidents." },
  { key: "reduce_cost", name: "Reduce cost", description: "Consolidating tools or vendors, or cutting spend." },
  { key: "improve_efficiency", name: "Improve efficiency", description: "Wants less manual work and analyst time." },
  { key: "meet_compliance", name: "Meet a compliance requirement", description: "Driven by an audit, regulation, customer or insurer." },
];

export const templateByKey = (key: string | null) =>
  OUTCOME_TEMPLATES.find((t) => t.key === key) ?? null;
